import type { feature_approval_status_enum } from '@vrplatform/graphql';

export type Feature = keyof typeof features;

export const features = {
  OVERVIEW_UI: 'xxx',
  CUSTOM_FEE_MULTI_CURRENCY_INPUTS: '1e5982bd-b597-4288-b9d1-51cb54440e5e',
  GL_WITH_LEGACY_AUTOMATIONS: 'b76f85d5-9627-4f6b-a943-080304c0de68',
  SETUP_GUIDE_UI: '43715fd0-1b82-49c4-b393-0ac97d21986d',
  API_KEY_ACCESS: '7263f893-1dd6-4ff8-97cf-f30a75bd3dd1',
  OPEX: '7c3bdd04-b331-4595-b383-1462ee2a452f',
  BANK_RULES: '76ede7c2-d23d-4ac5-a901-232ca6b38c11',
  CSV_IMPORT_MODAL: 'd9b06cd7-5f5c-4709-a6a4-d2fa934d4d0a',
} as const;

export const getEnabledFeatures = ({
  isV2,
  userApprovals,
  teamFeatures,
}: {
  isV2: boolean;
  userApprovals: {
    status: feature_approval_status_enum | undefined;
    featureId: string;
  }[];
  teamFeatures: {
    featureId: string;
    status: feature_approval_status_enum | undefined;
  }[];
}): Record<keyof typeof features, boolean> => {
  return Object.entries(features).reduce((state, [key, value]) => {
    const returnState = (value: boolean) => {
      state[key] = value;
      return state;
    };

    // Hirarchy:
    // 1. SPOTLIGHT_V2_UI => any feature with "_UI" suffix
    // 2. Tester
    // 3. Enabled team
    const isSpotlightV2_UI = key.endsWith('_UI') && isV2;

    if (isSpotlightV2_UI) return returnState(true);

    const testerStatus = userApprovals.find(
      (approval) => approval.featureId === value
    )?.status;

    // if tester and always enabled
    if (testerStatus) {
      if (testerStatus === 'all') return returnState(true);
      if (testerStatus === 'disabled') return returnState(false);
    }

    const teamStatus = teamFeatures.find(
      (enabledFeature) => enabledFeature.featureId === value
    )?.status;

    // if team is testing
    if (teamStatus) {
      if (teamStatus === 'all') return returnState(true);
      if (teamStatus === 'partially' && testerStatus === 'partially')
        return returnState(true);
      if (teamStatus === 'disabled') return returnState(false);
    }

    return returnState(false);
  }, {} as any);
};
